export const TRANSLATION_PATH = (route) => {
  return `components.user.register.userForm.${route}`;
};
